import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-devolucao-edit',
  templateUrl: './devolucao-edit.component.html',
  styleUrls: ['./devolucao-edit.component.css'],
  standalone: false
})
export class DevolucaoEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/devolucao`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Devolução', link: '/devolucao' }, { label: 'Edição Devolução' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'devolucao',
      // saveNew: '/devolucao',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("devolucao").subscribe((data) => {
        this.fields = data;
    });
  }
}
